import { Component, Injector, OnInit } from '@angular/core';
import { ReceivableService } from 'src/app/services/receivable.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserTransaction, UserTransactionDetail } from 'src/app/models/receivable';
import { UserTransactionStatus } from 'src/app/models/account';

@Component({
  selector: 'app-detail-payment',
  templateUrl: './detail-payment.component.html',
  styleUrls: ['./detail-payment.component.css']
})
export class DetailPaymentComponent implements OnInit {
  public transaction: UserTransaction;
  public detail: UserTransactionDetail;
  isLoading = false;

  get getStatus() { return UserTransactionStatus; }

  constructor(
    public receivableService: ReceivableService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this.getTransactionDetail();
    //setInterval(() => { this.getTransactionDetail(); }, 10000);
  }

  getTransactionDetail() {
    const transaction = this.route.snapshot.paramMap.get('data');
    if (transaction != null) {
      try {
        this.transaction = JSON.parse(atob(transaction));
        this.receivableService.getUserTransactionDetail(this.transaction.id,
          (data) => {
            this.detail = data;
            this.isLoading = false;
          },
          (err) => {
            console.log(err);
          });
      } catch { this.transaction = null; }
    }

    if (this.detail === null) {
      this.router.navigate(['receivable']);
    }
  }
}
